
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";

function App() {
  return (
    <div className="app">
      <br />
      <h1>WeekendMovs</h1>
      <br />
      <Navbar />
      <br />
      <Home />
    </div>
  );
}

export default App;
